export default __webpack_public_path__ + "static/media/RayanBenaissa.4d08b35a.webp";